module.exports = __webpack_public_path__ + "static/sport/bgi-h5.27f9a0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/trea/bgi-h5.jpg
// module id = tfNC
// module chunks = 0